// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"32943":"a84403c3","79594":"43aea0cd"}[chunkId] + ".chunk.min.css";
};